<template>
    <div class="wrapper">
        <Header />
        <!-- <side-bar v-if="$store.state.authentication.user_role == 'super-admin'"> -->
        <side-bar>
            <sidebar-link to="/dashboard">
                <md-icon>dashboard</md-icon>
                <p>{{translate(locale.dashboard)}}</p>
            </sidebar-link>
            <div
                style="margin: 10px 0 10px 15px; height: 1px; width: calc(100% - 30px);background-color: rgba(180, 180, 180, 0.3);">
            </div>
            <sidebar-link to="/films" v-if="allow_user('super-admin|operation-admin|film-admin')">
                <md-icon>video_call</md-icon>
                <p>ការគ្រប់គ្រងភាពយន្ត</p>
            </sidebar-link>
            <sidebar-link to="/payments" v-if="allow_user('super-admin|operation-admin|payment-admin')">
                <md-icon>paid</md-icon>
                <p>ការគ្រប់គ្រងប្រតិបត្តិការ</p>
            </sidebar-link>
            <sidebar-link to="/referrals" v-if="allow_user('super-admin|operation-admin|payment-admin')">
                <md-icon>person_add_alt</md-icon>
                <p>ការគ្រប់គ្រងអ្នកណែនាំ</p>
            </sidebar-link>
            <sidebar-link to="/users" v-if="allow_user('super-admin|operation-admin|payment-admin')">
                <md-icon>groups</md-icon>
                <p>ការគ្រប់គ្រងអ្នកប្រើប្រាស់</p>
            </sidebar-link>
            <sidebar-link to="/coupons" v-if="allow_user('super-admin|operation-admin')">
                <md-icon>confirmation_number</md-icon>
                <p>ការគ្រប់គ្រងគូប៉ុង</p>
            </sidebar-link>
            <sidebar-link to="/slideshows" v-if="allow_user('super-admin|operation-admin|film-admin')">
                <md-icon>compare</md-icon>
                <p>ការគ្រប់គ្រងផ្ទាំងស្លាយ</p>
            </sidebar-link>
            <sidebar-link to="/transactions" v-if="allow_user('super-admin|operation-admin')">
                <md-icon>currency_exchange</md-icon>
                <p>ប្រវត្តិទូទាត់ប្រាក់</p>
            </sidebar-link>
            <sidebar-link to="/notifications" v-if="allow_user('super-admin|operation-admin')">
                <md-icon>notifications</md-icon>
                <p>ការគ្រប់គ្រងសារជូនដំណឹង</p>
            </sidebar-link>
            <sidebar-link to="/partners" v-if="allow_user('super-admin|operation-admin')">
                <md-icon>business_center</md-icon>
                <p>ការគ្រប់គ្រងដៃគូសហការ</p>
            </sidebar-link>
            <sidebar-link to="/actors" v-if="allow_user('super-admin|operation-admin|film-admin')">
                <md-icon>video_camera_front</md-icon>
                <p>គ្រប់គ្រងតួអង្គ</p>
            </sidebar-link>
            <sidebar-link to="/trailers" v-if="allow_user('super-admin|operation-admin|film-admin')">
                <md-icon>live_tv</md-icon>
                <p>វីដេអូឈុតខ្លីៗ</p>
            </sidebar-link>
            <sidebar-link to="/administrators" v-if="allow_user('super-admin')">
                <md-icon>supervised_user_circle</md-icon>
                <p>ការគ្រប់គ្រងអ្នកគ្រប់គ្រង</p>
            </sidebar-link>
            <sidebar-link to="/settings" v-if="allow_user('super-admin')">
                <md-icon>settings</md-icon>
                <p>ការកំណត់ប្រព័ន្ធ</p>
            </sidebar-link>
        </side-bar>

        <div class="main-panel" style="padding-top:80px">

            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>

            <Footer />
        </div>
    </div>
</template>

<script>
    import Footer from '../components/Footer.vue'
    import Header from '../components/Header.vue'

    export default {
        components: { Header, Footer },
        methods: {
        }
    }
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
</style>


// WEBPACK FOOTER //
// src/pages/Layout.vue